import acInterceptor from '../acInterceptor';
import { useRequest } from 'alova';
import { transformTrackPayload } from './transformPayload';
import { SortingDebtReqProps, SortingDebtResponse, SortingDebtInvalidateCacheProps } from './types';
import { useDogxContext } from '@libs/dogx';

const headers = {
  'Content-Type': 'application/json;charset=UTF-8',
  'Access-Control-Allow-Origin': '*',
};

const useApiSortingDebt = () => {
  const baseURL = import.meta.env.VITE_NEW_SORTING_DEBT_API_URL;
  const { getExperimentVariant } = useDogxContext();
  const experimentVariant = getExperimentVariant('dx-smart-cj');

  const apiSortingDebtTrack = useRequest(
    (payload: SortingDebtReqProps) => {
      const safePayload = payload || {};

      if (experimentVariant !== 'control') {
        safePayload.parameters = {
          variant: 'restricted-journey',
        };
      }

      return acInterceptor({ baseURL }).Post<SortingDebtResponse>('/sorting-debt/v1/app/debt/track', transformTrackPayload(safePayload), {
        headers: headers,
      });
    },
    {
      immediate: false,
    }
  );

  const apiSortingDebtInvalidateCache = useRequest(
    (payload: SortingDebtInvalidateCacheProps) =>
      acInterceptor({ baseURL }).Post<SortingDebtResponse>('/sorting-debt/v1/public/debt/invalidate', payload, {
        headers: headers,
      }),
    {
      immediate: false,
    }
  );

  return { apiSortingDebtTrack, apiSortingDebtInvalidateCache };
};

export default useApiSortingDebt;
